"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trafficSurveyQuestionAnswered = exports.trafficSurveyQuestionShown = exports.trafficUserQueued = exports.trafficUserIdle = exports.trafficUserLeaveQueue = exports.trafficRacTriggered = exports.trafficChatResetClick = exports.trafficEndChatClick = exports.trafficLESocketOnOpen = exports.trafficLESocketOnMessage = exports.trafficLESocketOnError = exports.trafficLESocketOnClose = exports.trafficAgentUnavailable = exports.trafficAgentActionStart = exports.trafficAgentActionMessageSent = exports.trafficAgentActionEnd = exports.trafficBotActionStart = exports.trafficBotActionMessageSent = exports.trafficBotActionButtonView = exports.trafficBotActionButtonClick = exports.trafficUtteranceSubmit = void 0;

var _Traffic = _interopRequireDefault(require("../../clients/Traffic"));

var _constants = require("../../constants");

var _conversation = require("../selectors/conversation");

var _app = require("../selectors/app");

var _survey = require("../selectors/survey");

var _survey2 = require("../actions/survey");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getGenericProperties = function getGenericProperties(getState) {
  var state = getState();
  var sid = (0, _app.getAppSessionId)(state);
  var productId = (0, _app.getAppProduct)(state);
  var projectId = (0, _app.getAppBotProjectId)(state);
  return {
    sid: sid,
    productId: productId,
    projectId: projectId
  };
};

var parseSurveyQuestionData = function parseSurveyQuestionData(intent) {
  // Sample intent: 'q1 satisfaction with guide 0-10|1|abc123|css'
  var data = intent.split('|');

  if (data.length === 4) {
    var ordinal = data[1];
    var questionId = data[2];
    var type = data[3];
    return {
      ordinal: ordinal,
      questionId: questionId,
      type: type
    };
  }

  return {};
};

var getSurveyQuestionData = function getSurveyQuestionData(getState) {
  var state = getState();
  var conversationId = (0, _app.getAppConversationId)(state);
  var currentQuestion = (0, _survey.getSurveyCurrentQuestion)(state);
  return _objectSpread({
    conversationId: conversationId
  }, currentQuestion);
};

var trafficUtteranceSubmit = function trafficUtteranceSubmit(_ref) {
  var utterance = _ref.utterance;
  return function (dispatch, getState) {
    var conversationUtterances = (0, _conversation.getConversationUtterances)(getState());

    if (conversationUtterances.length === 1) {
      _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_INPUT_SUBMIT, {
        first: true,
        value: utterance
      });
    } else {
      _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_INPUT_SUBMIT, {
        first: false,
        value: utterance
      });
    }
  };
};

exports.trafficUtteranceSubmit = trafficUtteranceSubmit;

var trafficBotActionButtonClick = function trafficBotActionButtonClick(_ref2) {
  var text = _ref2.text;
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_BOT_BUTTON_CLICK, _objectSpread({
      text: text
    }, genericProperties));
  };
};

exports.trafficBotActionButtonClick = trafficBotActionButtonClick;

var trafficBotActionButtonView = function trafficBotActionButtonView(buttons) {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_BOT_BUTTON_VIEW, _objectSpread({
      buttons: buttons
    }, genericProperties));
  };
};

exports.trafficBotActionButtonView = trafficBotActionButtonView;

var trafficBotActionMessageSent = function trafficBotActionMessageSent(botMessage) {
  return function (dispatch, getState) {
    var intent = botMessage.intent,
        type = botMessage.type,
        message = botMessage.message; // Currently we only send text for type text Payload. For other payloads we only send intentName and type.

    var text = type === _constants.PAYLOAD_TYPE.TEXT && message.text || '';
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_BOT_MESSAGE_SENT, _objectSpread({}, genericProperties, {
      intent: intent,
      type: type,
      text: text
    }));
  };
};

exports.trafficBotActionMessageSent = trafficBotActionMessageSent;

var trafficBotActionStart = function trafficBotActionStart() {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_BOT_START, _objectSpread({}, genericProperties));
  };
};

exports.trafficBotActionStart = trafficBotActionStart;

var trafficAgentActionEnd = function trafficAgentActionEnd() {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_AGENT_END, _objectSpread({}, genericProperties));
  };
};

exports.trafficAgentActionEnd = trafficAgentActionEnd;

var trafficAgentActionMessageSent = function trafficAgentActionMessageSent() {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_AGENT_MESSAGE_SENT, _objectSpread({}, genericProperties));
  };
};

exports.trafficAgentActionMessageSent = trafficAgentActionMessageSent;

var trafficAgentActionStart = function trafficAgentActionStart() {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);
    var conversationId = (0, _app.getAppConversationId)(getState());

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_AGENT_START, _objectSpread({}, genericProperties, {
      conversationId: conversationId
    }));
  };
};

exports.trafficAgentActionStart = trafficAgentActionStart;

var trafficAgentUnavailable = function trafficAgentUnavailable() {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);
    var conversationId = (0, _app.getAppConversationId)(getState());

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_AGENT_UNAVAILABLE, _objectSpread({}, genericProperties, {
      conversationId: conversationId
    }));
  };
};

exports.trafficAgentUnavailable = trafficAgentUnavailable;

var trafficLESocketOnClose = function trafficLESocketOnClose() {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_LE_SOCKET_ONCLOSE, _objectSpread({}, genericProperties));
  };
};

exports.trafficLESocketOnClose = trafficLESocketOnClose;

var trafficLESocketOnError = function trafficLESocketOnError(socketError) {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_LE_SOCKET_ONERROR, _objectSpread({}, genericProperties, {
      socketError: socketError
    }));
  };
};

exports.trafficLESocketOnError = trafficLESocketOnError;

var trafficLESocketOnMessage = function trafficLESocketOnMessage(socketMessage) {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_LE_SOCKET_ONMESSAGE, _objectSpread({}, genericProperties, {
      socketMessage: socketMessage
    }));
  };
};

exports.trafficLESocketOnMessage = trafficLESocketOnMessage;

var trafficLESocketOnOpen = function trafficLESocketOnOpen() {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_LE_SOCKET_ONOPEN, _objectSpread({}, genericProperties));
  };
};

exports.trafficLESocketOnOpen = trafficLESocketOnOpen;

var trafficEndChatClick = function trafficEndChatClick() {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_END_CHAT_CLICK, _objectSpread({}, genericProperties));
  };
};

exports.trafficEndChatClick = trafficEndChatClick;

var trafficChatResetClick = function trafficChatResetClick() {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_CHAT_RESET_CLICK, _objectSpread({}, genericProperties));
  };
};

exports.trafficChatResetClick = trafficChatResetClick;

var trafficRacTriggered = function trafficRacTriggered(racTrafficData) {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_RAC_CALLED, _objectSpread({}, genericProperties, {
      agentDisplay: racTrafficData.agentDisplay,
      callbackTime: racTrafficData.callbackTime,
      callbackEndTime: racTrafficData.callbackEndTime,
      callTypeID: racTrafficData.callTypeID,
      routeId: racTrafficData.routeId,
      shopperId: racTrafficData.shopperId,
      status: racTrafficData.status,
      timeStamp: racTrafficData.timeStamp,
      ucid: racTrafficData.ucid,
      visitorId: racTrafficData.visitorId,
      waitTime: racTrafficData.waitTime
    }));
  };
};

exports.trafficRacTriggered = trafficRacTriggered;

var trafficUserLeaveQueue = function trafficUserLeaveQueue() {
  return function (dispatch, getState) {
    var genericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_CHAT_LEAVE_QUEUE_CLICK, _objectSpread({}, genericProperties));
  };
};

exports.trafficUserLeaveQueue = trafficUserLeaveQueue;

var trafficUserIdle = function trafficUserIdle() {
  return function (dispatch, getState) {
    var botGenericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_USER_IDLE, _objectSpread({}, botGenericProperties));
  };
};

exports.trafficUserIdle = trafficUserIdle;

var trafficUserQueued = function trafficUserQueued() {
  return function (dispatch, getState) {
    var botGenericProperties = getGenericProperties(getState);

    _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_USER_QUEUED, _objectSpread({}, botGenericProperties));
  };
};

exports.trafficUserQueued = trafficUserQueued;

var trafficSurveyQuestionShown = function trafficSurveyQuestionShown(botMessage) {
  return function (dispatch, getState) {
    var intent = botMessage.intent,
        type = botMessage.type,
        text = botMessage.message.text;
    var projectId = (0, _app.getAppBotProjectId)(getState());

    if (projectId === _constants.PROJECT_ID_CSS_SURVEY_BOT && type === 'text') {
      var genericProperties = getGenericProperties(getState);
      var conversationId = (0, _app.getAppConversationId)(getState());
      var questionData = parseSurveyQuestionData(intent);
      dispatch((0, _survey2.surveyCurrentQuestionSet)(_objectSpread({
        text: text
      }, questionData)));

      _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_SURVEY_QUESTION_SHOWN, _objectSpread({}, genericProperties, {
        conversationId: conversationId
      }, questionData, {
        text: text
      }));
    }
  };
};

exports.trafficSurveyQuestionShown = trafficSurveyQuestionShown;

var trafficSurveyQuestionAnswered = function trafficSurveyQuestionAnswered(answer) {
  return function (dispatch, getState) {
    var projectId = (0, _app.getAppBotProjectId)(getState());

    if (projectId === _constants.PROJECT_ID_CSS_SURVEY_BOT) {
      var genericProperties = getGenericProperties(getState);
      var questionData = getSurveyQuestionData(getState);

      _Traffic["default"].sendEvent(_constants.TRAFFIC_EID_SURVEY_QUESTION_ANSWERED, _objectSpread({}, genericProperties, {}, questionData, {
        answer: answer
      }));
    }
  };
};

exports.trafficSurveyQuestionAnswered = trafficSurveyQuestionAnswered;